import { js_utils } from "./frfr-js-utils";


// const frfr_lib_changes_id = '/FRFR/frfr-dmd-utils.js/changes_id2025-10-20r1/';


// FRFR UNDER CONSTRUCTION FRFR TODO
/* 
FrFr FRIENDLY FRAMEWORK
frfr-dmd-utils
Version ID: 1a 2025-11-29r1
by 
// Please describe here if you customized this file
*/


// DMD (DATA + METADATA) COMBINED OBJECT UTILS

/*
INSPIRACIJA
dmd_pack

*/

//
// export const frfr_dmd_utils = {};
export const dmd_utils = {};


//
const dmd_example = {
  thisis: 'DMD',
  meta: {
    type_is_arr: true,
    fetching: true,
    freshness: 0,
  },
  payload: [],
};


// create new dmd for holding arr type of data
dmd_utils.create_type_arr = () => {
  let _dmd = {};
  if (true) {
    _dmd.thisis = 'DMD';
    // _dmd.type_is_arr = true;
    // _dmd.arr = [];
    // _dmd.item = {};
    // _dmd.fetching = true;
    _dmd.meta = {
      type_is_arr: true,
      fetching: false,
      freshness: 0,
    };
    _dmd.payload = [];
  }
  return _dmd;
};


// create new dmd for holding data type of object
dmd_utils.create_type_obj = () => {
  let _dmd = {};
  if (true) {
    _dmd.thisis = 'DMD';
    // _dmd.type_is_arr = true;
    // _dmd.arr = [];
    // _dmd.item = {};
    // _dmd.fetching = true;
    _dmd.meta = {
      // type_is_arr: true,
      type_is_obj: true,
      fetching: false,
      freshness: 0,
    };
    // _dmd.payload = [];
    _dmd.payload = {};
  }
  return _dmd;
};


//
const _dmd_utils_clone_smart = (dmd_obj) => {
  // DIRTY CLONE
  const payload_ref = dmd_obj.payload;
  const dmd_clone = { ...dmd_obj }; // NEW REFERENCE FOR dmd
  dmd_clone.payload = payload_ref; // SAME REFERENCE FOR UNCHANGED DATA
  dmd_clone.meta = { ...dmd_obj.meta }; // NEW REFERENCE FOR meta
  return dmd_clone;
};


//
const _dmd_utils_clone_pure = (dmd_obj) => {
  return js_utils.pure_clone_by_json(dmd_obj); // PURE CLONE
};


//
dmd_utils.pure_clone = (dmd) => {
  return _dmd_utils_clone_pure(dmd);
};


//
// inspired by json_utils.js_to_always_json(val)
dmd_utils.is_fetching = (dmd) => {
  if (dmd?.meta?.fetching === true) {
    return true;
  }
  return false;
};


//
dmd_utils.update_fetching = (dmd, fetching, clear_arr) => {
  const updated_dmd = _dmd_utils_clone_smart(dmd);
  if (fetching === true) {
    updated_dmd.meta.fetching = true;
    if (clear_arr === false) {
      // do nothing
    } else { // DEFAULT clear_arr on fetching === true
      if (updated_dmd.meta && updated_dmd.meta.type_is_obj === true) {
        updated_dmd.payload = {}; // clear obj
      } else {
        updated_dmd.payload = []; // clear arr
      }
    }
  } else {
    updated_dmd.meta.fetching = false;
    if (clear_arr === true) {
      if (updated_dmd.meta && updated_dmd.meta.type_is_obj === true) {
        updated_dmd.payload = {}; // clear obj
      } else {
        updated_dmd.payload = []; // clear arr
      }
    } else { // DEFAULT leave arr on fetching === false
      // do nothing
    }
  }
  updated_dmd.meta.freshness = updated_dmd.meta.freshness + 1; // FRESHENSS
  return updated_dmd;
};


//
dmd_utils.update_arr = (dmd, arr, fetching) => {
  const updated_dmd = _dmd_utils_clone_smart(dmd);
  if (Array.isArray(arr)) {
    updated_dmd.payload = arr;
  }
  if (fetching === true) {
    updated_dmd.meta.fetching = true;
  } else {
    updated_dmd.meta.fetching = false;
  }
  updated_dmd.meta.freshness = updated_dmd.meta.freshness + 1; // FRESHENSS
  return updated_dmd;
};

//
dmd_utils.update_obj = (dmd, obj, fetching) => {
  const updated_dmd = _dmd_utils_clone_smart(dmd);
  if (Array.isArray(obj)) {
    updated_dmd.payload = obj;
  }
  if (fetching === true) {
    updated_dmd.meta.fetching = true;
  } else {
    updated_dmd.meta.fetching = false;
  }
  updated_dmd.meta.freshness = updated_dmd.meta.freshness + 1; // FRESHENSS
  return updated_dmd;
};


//
// inspired by json_utils.js_to_always_json(val)
dmd_utils.dmd_to_always_arr = (dmd) => {
  // let arr = [];
  if (Array.isArray(dmd?.payload)) {
    // arr = dmd.payload;
    return dmd.payload;
  }
  return [];
};

//
dmd_utils.dmd_to_always_obj = (dmd) => {
  // let obj = {};
  if (js_utils.is_object(dmd?.payload)) {
    // obj = dmd.payload;
    return dmd.payload;
  }
  return {};
};


// TODO
const dmd_utils_prepare_smart = (dmd_obj) => {
  let _dmd = {};
  if (dmd_obj?.meta?.fetching === true) {
    _dmd.type_is_arr = true;
    _dmd.arr = [];
    _dmd.item = {};
    _dmd.fetching = true;
  } else {
    _dmd.arr = dmd_obj.payload;
    _dmd.item = dmd_obj.payload;
    _dmd.fetching = false;
  }
  return _dmd;
};

